export const CATEGORY_LIST_CACHE = 'CACHE.KEY.CATEGORY.LIST'
export const CATEGORY_LIST_PARENT_CACHE = 'CACHE.KEY.CATEGORY.LIST_PARENT'
export const CATEGORY_LIST_BY_PARENT_CACHE = 'CACHE.KEY.CATEGORY.LIST_BY_PARENT.' // +parentId
